export default __webpack_public_path__ + "./images/ch.6c48100e.png";